import {
    ADD_BANK_ACCOUNT_START,
    ADD_BANK_ACCOUNT_SUCCESS,
    ADD_BANK_ACCOUNT_FAILURE,
    GET_BANK_ACCOUNT_START,
    GET_BANK_ACCOUNT_SUCCESS,
    GET_BANK_ACCOUNT_FAILURE,
    DELETE_BANK_ACCOUNT_START,
    DELETE_BANK_ACCOUNT_SUCCESS,
    DELETE_BANK_ACCOUNT_FAILURE,
    MAKE_DEFAULT_BANK_ACCOUNT_START,
    MAKE_DEFAULT_BANK_ACCOUNT_SUCCESS,
    MAKE_DEFAULT_BANK_ACCOUNT_FAILURE,
    VIEW_BANK_ACCOUNT_START,
    VIEW_BANK_ACCOUNT_SUCCESS,
    VIEW_BANK_ACCOUNT_FAILURE,
    WITHIN_PAY_USER_LIST_START,
    WITHIN_PAY_USER_LIST_SUCCESS,
    WITHIN_PAY_USER_LIST_FAILURE,
    CREATE_WITHIN_PAY_USER_START,
    CREATE_WITHIN_PAY_USER_SUCCESS,
    CREATE_WITHIN_PAY_USER_FAILURE,
    DELETE_WITHIN_PAY_USER_START,
    DELETE_WITHIN_PAY_USER_SUCCESS,
    DELETE_WITHIN_PAY_USER_FAILURE,
    SINGLE_VIEW_WITHIN_PAY_USER_FAILURE,
    SINGLE_VIEW_WITHIN_PAY_USER_START,
    SINGLE_VIEW_WITHIN_PAY_USER_SUCCESS,
    WHITELIST_ADDRESS_LIST_START,
    WHITELIST_ADDRESS_LIST_SUCCESS,
    WHITELIST_ADDRESS_LIST_FAILURE,
    CREATE_WHITELIST_ADDRESS_START,
    CREATE_WHITELIST_ADDRESS_SUCCESS,
    CREATE_WHITELIST_ADDRESS_FAILURE,
    DELETE_WHITELIST_ADDRESS_START,
    DELETE_WHITELIST_ADDRESS_SUCCESS,
    DELETE_WHITELIST_ADDRESS_FAILURE,
    SINGLE_VIEW_WHITELIST_ADDRESS_FAILURE,
    SINGLE_VIEW_WHITELIST_ADDRESS_START,
    SINGLE_VIEW_WHITELIST_ADDRESS_SUCCESS,
    SEND_MONEY_WITHIN_PAY_START,
    SEND_MONEY_WITHIN_PAY_SUCCESS,
    SEND_MONEY_WITHIN_PAY_FAILURE,
    STATIC_EXCHANGE_RATE_START,
    STATIC_EXCHANGE_RATE_SUCCESS,
    STATIC_EXCHANGE_RATE_FAILURE,
    STATIC_EMAIL_LIST_START,
    STATIC_EMAIL_LIST_SUCCESS,
    STATIC_EMAIL_LIST_FAILURE,
    BVNK_FEES_START,
    BVNK_FEES_SUCCESS,
    BVNK_FEES_FAILURE,
    SDK_KEY_GENERATE_START,
    SDK_KEY_GENERATE_SUCCESS,
    SDK_KEY_GENERATE_FAILURE,
    WITHDRAWAL_DOWNLOAD_START,
    WITHDRAWAL_DOWNLOAD_SUCCESS,
    WITHDRAWAL_DOWNLOAD_FAILURE,
    VERIFY_CODE_RESET_PASSWORD_START,
    VERIFY_CODE_RESET_PASSWORD_SUCCESS,
    VERIFY_CODE_RESET_PASSWORD_FAILURE,
    ACCEPT_INVITE_START,
    ACCEPT_INVITE_SUCCESS,
    ACCEPT_INVITE_FAILURE,
  } from "../actions/ActionConstant";
  
  const initialState = {
    addBankAccount: {
      data: {},
      loading: true,
      error: false,
      loadingButtonContent: null,
      buttonDisable: false,
    },
    bankAccount: {
      data: {},
      loading: true,
      error: false,
    },
    deleteAccount: {
      data: {},
      loading: true,
      error: false,
    },
    makeDefault: {
      data: {},
      loading: true,
      error: false,
    },
    viewAccount: {
      data: {},
      loading: true,
      error: false,
    },
    withinPayUserList: {
      data: {},
      loading: true,
      error: false,
    },
    createWithinPayUser: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    deleteWithinPayUser: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    singleViewWithinPayUser: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    sendMoneyWithinPay:{
      data: {},
      loading:true,
      error:false,
      buttonDisable:false,
    },
    // Whitelist Address
    whitelistAddressList: {
      data: {},
      loading: true,
      error: false,
    },
    createWhitelistAddress: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    deleteWhitelistAddress: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    singleViewWhitelistAddress: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    staticExchangeRate: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    staticEmailList: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    bvnkFees: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    sdkKeyGenerate: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    withdrawalDownload: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    verifyCodeResetPassword: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    },
    acceptInvite: {
      data: {},
      loading: true,
      error: false,
      buttonDisable: false,
    }
  };
  
  const BankAccountReducer = (state = initialState, action) => {
    switch (action.type) {
      case ADD_BANK_ACCOUNT_START:
        return {
          ...state,
          addBankAccount: {
            data: {},
            loading: true,
            error: false,
            loadingButtonContent: "Loading... Please wait",
            buttonDisable: true,
          },
        };
      case ADD_BANK_ACCOUNT_SUCCESS:
        return {
          ...state,
          addBankAccount: {
            data: action.data,
            loading: false,
            error: false,
            loadingButtonContent: null,
            buttonDisable: false,
          },
        };
      case ADD_BANK_ACCOUNT_FAILURE:
        return {
          ...state,
          addBankAccount: {
            data: {},
            loading: true,
            error: action.error,
            loadingButtonContent: null,
            buttonDisable: false,
          },
        };
      case GET_BANK_ACCOUNT_START:
        return {
          ...state,
          bankAccount: {
            data: {},
            loading: true,
            error: false,
          },
        };
      case GET_BANK_ACCOUNT_SUCCESS:
        return {
          ...state,
          bankAccount: {
            data: action.data,
            loading: false,
            error: false,
          },
        };
      case GET_BANK_ACCOUNT_FAILURE:
        return {
          ...state,
          bankAccount: {
            data: {},
            loading:true,
            error: action.error,
          },
        };
      case DELETE_BANK_ACCOUNT_START:
        return {
          ...state,
          deleteAccount: {
            data: {},
            loading: true,
            error: false,
          },
        };
      case DELETE_BANK_ACCOUNT_SUCCESS:
        return {
          ...state,
          deleteAccount: {
            data: action.data,
            loading: false,
            error: false,
          },
        };
      case DELETE_BANK_ACCOUNT_FAILURE:
        return {
          ...state,
          deleteAccount: {
            data: {},
            loading: false,
            error: action.error,
          },
        };
      case MAKE_DEFAULT_BANK_ACCOUNT_START:
        return {
          ...state,
          makeDefault: {
            data: {},
            loading: true,
            error: false,
          },
        };
      case MAKE_DEFAULT_BANK_ACCOUNT_SUCCESS:
        return {
          ...state,
          makeDefault: {
            data: action.data,
            loading: false,
            error: false,
          },
        };
      case MAKE_DEFAULT_BANK_ACCOUNT_FAILURE:
        return {
          ...state,
          makeDefault: {
            data: {},
            loading: false,
            error: action.error,
          },
        };
      case VIEW_BANK_ACCOUNT_START:
        return {
          ...state,
          viewAccount: {
            data: {},
            loading: true,
            error: false,
  
  
          },
        };
      case VIEW_BANK_ACCOUNT_SUCCESS:
        return {
          ...state,
          viewAccount: {
            data: action.data,
            loading: false,
            error: false,
  
          },
        };
      case VIEW_BANK_ACCOUNT_FAILURE:
        return {
          ...state,
          viewAccount: {
            data: {},
            loading: false,
            error: action.error,
          },
        };
        case WITHIN_PAY_USER_LIST_START:
        return {
          ...state,
          withinPayUserList: {
            data: {},
            loading: true,
            error: false,
          },
        };
      case WITHIN_PAY_USER_LIST_SUCCESS:
        return {
          ...state,
          withinPayUserList: {
            data: action.data,
            loading: false,
            error: false,
          },
        };
      case WITHIN_PAY_USER_LIST_FAILURE:
        return {
          ...state,
          withinPayUserList: {
            data: {},
            loading: false,
            error: action.error,
          },
        };
        case CREATE_WITHIN_PAY_USER_START:
        return {
          ...state,
          createWithinPayUser: {
            data: {},
            loading: true,
            buttonDisable: true,
            error: false,
          },
        };
      case CREATE_WITHIN_PAY_USER_SUCCESS:
        return {
          ...state,
          createWithinPayUser: {
            data: action.data,
            loading: false,
            buttonDisable: false,
            error: false,
          },
        };
      case CREATE_WITHIN_PAY_USER_FAILURE:
        return {
          ...state,
          createWithinPayUser: {
            data: {},
            loading: false,
            buttonDisable: false,
            error: action.error,
          },
        };
        case DELETE_WITHIN_PAY_USER_START:
        return {
          ...state,
          deleteWithinPayUser: {
            data: {},
            loading: true,
            error: false,
            buttonDisable: true,
          },
        };
      case DELETE_WITHIN_PAY_USER_SUCCESS:
        return {
          ...state,
          deleteWithinPayUser: {
            data: action.data,
            loading: false,
            buttonDisable: false,
            error: false,
          },
        };
      case DELETE_WITHIN_PAY_USER_FAILURE:
        return {
          ...state,
          deleteWithinPayUser: {
            data: {},
            loading: false,
            buttonDisable: false,
            error: action.error,
          },
        };
        case SINGLE_VIEW_WITHIN_PAY_USER_START:
        return {
          ...state,
          singleViewWithinPayUser: {
            data: {},
            loading: true,
            error: false,
          },
        };
      case SINGLE_VIEW_WITHIN_PAY_USER_SUCCESS:
        return {
          ...state,
          singleViewWithinPayUser: {
            data: action.data,
            loading: false,
            error: false,
          },
        };
      case SINGLE_VIEW_WITHIN_PAY_USER_FAILURE: 
        return {
          ...state,
          singleViewWithinPayUser: {
            data: {},
            loading: false,
            error: action.error,
          },
        };

        case SEND_MONEY_WITHIN_PAY_START:
        return {
          ...state,
          sendMoneyWithinPay: {
            data: {},
            loading: true,
            error: false,
            buttonDisable: true,
          },
        };
      case SEND_MONEY_WITHIN_PAY_SUCCESS:
        return {
          ...state,
          sendMoneyWithinPay: {
            data: action.data,
            loading: false,
            error: false,
            buttonDisable: false,
          },
        };
      case SEND_MONEY_WITHIN_PAY_FAILURE:
        return {
          ...state,
          sendMoneyWithinPay: {
            data: {},
            loading: false,
            error: action.error,
            buttonDisable: false,
          },
        };

        // Whitelist Address
        case WHITELIST_ADDRESS_LIST_START:
          return {
            ...state,
            whitelistAddressList: {
              data: {},
              loading: true,
              error: false,
            },
          };
        case WHITELIST_ADDRESS_LIST_SUCCESS:
          return {
            ...state,
            whitelistAddressList: {
              data: action.data,
              loading: false,
              error: false,
            },
          };
        case WHITELIST_ADDRESS_LIST_FAILURE:
          return {
            ...state,
            whitelistAddressList: {
              data: {},
              loading: false,
              error: action.error,
            },
          };
        
        case CREATE_WHITELIST_ADDRESS_START:
          return {
            ...state,
            createWhitelistAddress: {
              data: {},
              loading: true,
              buttonDisable: true,
              error: false,
            },
          };
        case CREATE_WHITELIST_ADDRESS_SUCCESS:
          return {
            ...state,
            createWhitelistAddress: {
              data: action.data,
              loading: false,
              buttonDisable: false,
              error: false,
            },
          };
        case CREATE_WHITELIST_ADDRESS_FAILURE:
          return {
            ...state,
            createWhitelistAddress: {
              data: {},
              loading: false,
              buttonDisable: false,
              error: action.error,
            },
          };
          
        case DELETE_WHITELIST_ADDRESS_START:
          return {
            ...state,
            deleteWhitelistAddress: {
              data: {},
              loading: true,
              error: false,
              buttonDisable: true,
            },
          };
        case DELETE_WHITELIST_ADDRESS_SUCCESS:
          return {
            ...state,
            deleteWhitelistAddress: {
              data: action.data,
              loading: false,
              buttonDisable: false,
              error: false,
            },
          };
        case DELETE_WHITELIST_ADDRESS_FAILURE:
          return {
            ...state,
            deleteWhitelistAddress: {
              data: {},
              loading: false,
              buttonDisable: false,
              error: action.error,
            },
          };
         
        case SINGLE_VIEW_WHITELIST_ADDRESS_START:
          return {
            ...state,
            singleViewWhitelistAddress: {
              data: {},
              loading: true,
              error: false,
            },
          };
        case SINGLE_VIEW_WHITELIST_ADDRESS_SUCCESS:
          return {
            ...state,
            singleViewWhitelistAddress: {
              data: action.data,
              loading: false,
              error: false,
            },
          };
        case SINGLE_VIEW_WHITELIST_ADDRESS_FAILURE: 
          return {
            ...state,
            singleViewWhitelistAddress: {
              data: {},
              loading: false,
              error: action.error,
            },
          };

      // Static Case

      case STATIC_EXCHANGE_RATE_START:
          return {
            ...state,
            staticExchangeRate: {
              data: {},
              loading: true,
              error: false,
            },
          };
      case STATIC_EXCHANGE_RATE_SUCCESS:
        return {
          ...state,
          staticExchangeRate: {
            data: action.data,
            loading: false,
            error: false,
          },
        };
      case STATIC_EXCHANGE_RATE_FAILURE: 
          return {
            ...state,
            staticExchangeRate: {
              data: {},
              loading: false,
              error: action.error,
            },
          };
  
      case STATIC_EMAIL_LIST_START:
        return {
          ...state,
          staticEmailList: {
            data: {},
            loading: true,
            error: false,
          },
        };
      case STATIC_EMAIL_LIST_SUCCESS:
        return {
          ...state,
          staticEmailList: {
            data: action.data,
            loading: false,
            error: false,
          },
        };
      case STATIC_EMAIL_LIST_FAILURE: 
          return {
            ...state,
            staticEmailList: {
              data: {},
              loading: false,
              error: action.error,
            },
          };
    
      // BVNK Fees

      case BVNK_FEES_START:
          return {
            ...state,
            bvnkFees: {
              data: {},
              loading: true,
              error: false,
            },
          };
      case BVNK_FEES_SUCCESS:
        return {
          ...state,
          bvnkFees: {
            data: action.data,
            loading: false,
            error: false,
          },
        };
      case BVNK_FEES_FAILURE: 
          return {
            ...state,
            bvnkFees: {
              data: {},
              loading: false,
              error: action.error,
            },
          };
  

      case SDK_KEY_GENERATE_START:
        return {
          ...state,
          sdkKeyGenerate: {
            data: {},
            loading: true,
            error: false,
            buttonDisable: true,
          },
        };
      case SDK_KEY_GENERATE_SUCCESS:
        return {
          ...state,
          sdkKeyGenerate: {
            data: action.data,
            loading: false,
            error: false,
            buttonDisable: false,
          },
        };
      case SDK_KEY_GENERATE_FAILURE: 
        return {
          ...state,
          sdkKeyGenerate: {
            data: {},
            loading: false,
            error: action.error,
            buttonDisable: false,
          },
        };


      case WITHDRAWAL_DOWNLOAD_START:
        return {
          ...state,
          withdrawalDownload: {
            data: {},
            loading: true,
            error: false,
            buttonDisable: true,
          },
        };
      case WITHDRAWAL_DOWNLOAD_SUCCESS:
        return {
          ...state,
          withdrawalDownload: {
            data: action.data,
            loading: false,
            error: false,
            buttonDisable: false,
          },
        };
      case WITHDRAWAL_DOWNLOAD_FAILURE: 
        return {
          ...state,
          withdrawalDownload: {
            data: {},
            loading: false,
            error: action.error,
            buttonDisable: false,
          },
        };

      case VERIFY_CODE_RESET_PASSWORD_START:
        return {
          ...state,
          verifyCodeResetPassword: {
            data: {},
            loading: true,
            error: false,
            buttonDisable: true,
          },
        };
      case VERIFY_CODE_RESET_PASSWORD_SUCCESS:
        return {
          ...state,
          verifyCodeResetPassword: {
            data: action.data,
            loading: false,
            error: false,
            buttonDisable: false,
          },
        };
      case VERIFY_CODE_RESET_PASSWORD_FAILURE: 
          return {
            ...state,
            verifyCodeResetPassword: {
              data: {},
              loading: false,
              error: action.error,
              buttonDisable: false,
            },
          };
  
      case ACCEPT_INVITE_START:
        return {
          ...state,
          acceptInvite: {
            data: {},
            loading: true,
            error: false,
            buttonDisable: true,
          },
        };
      case ACCEPT_INVITE_SUCCESS:
        return {
          ...state,
          acceptInvite: {
            data: action.data,
            loading: false,
            error: false,
            buttonDisable: false,
          },
        };
      case ACCEPT_INVITE_FAILURE: 
          return {
            ...state,
            acceptInvite: {
              data: {},
              loading: false,
              error: action.error,
              buttonDisable: false,
            },
          };
  
      default:
        return state;
    }
  };
  export default BankAccountReducer;
  